module.exports = __webpack_public_path__ + "img/google.6632e214.png";